import { Draft } from 'immer';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import constants from '../constants';
import { stringsContainsIgnoreCase, stringsEqualIgnoreCase } from '../util';
import {nowMillisecond} from "../dateUtils";
import _ from 'lodash';

export interface MoveJobToTop {
  url: string,
  operation: string,
};

export interface MoveJobToOperation {
  url: string,
  sourceOperation: string,
  destinationOperation: string,
}

export interface AddJobMenuItem {
  url: string,
  label: any,
  parentUrl: string|null,
  operation: string|null,
  activeOperation: string|null,
  closeOnLogout: boolean,
  metadata: any|null,
  timestamp: string|null,
  noOperationSuffix?: boolean,
  afterScreenUrl: string|null,
  jobMode?:string,
  jobType?:string,
  addTypeSuffix?: boolean,
};

export interface ReplaceJobMenuItem {
  oldUrl: string,
  newUrl: string,
  oldLabel: any,
  newLabel: any,
  metadata: any|null,
  noOperationSuffix?: boolean,
};

export interface ReplaceParentOpJobMenuItem {
  url: string,
};

export interface RemoveJobMenuItem {
  url: string,
  activeOperation: string|null,
};

export interface ReplaceJobMenuItemMetadata {
  url: string,
  metadata: any|null,
};

export interface ReplaceJobMenuItemTimestamp {
  url: string,
  timestamp: string,
};

export interface JobMenuItem {
  url: string,
  label: any,
  parentUrl: string|null,
  operationName: string|null,
  closeOnLogout: boolean,
  metadata: any|null,
  counter: number, // For internal redraw logic
  timestamp?: string,
  noOperationSuffix: boolean,
  afterScreenUrl?:string|null,
  jobMode?:string,
  jobType?:string,
  addTypeSuffix?: boolean,
};

export interface JobMenuState  {
  [key: string]: Array<JobMenuItem>,
  oceanImport: Array<JobMenuItem>,
  oceanExport: Array<JobMenuItem>,
  airImport: Array<JobMenuItem>,
  airExport: Array<JobMenuItem>,
  otherShipment: Array<JobMenuItem>,
  accounting: Array<JobMenuItem>,
  warehousing: Array<JobMenuItem>,
  customer: Array<JobMenuItem>,
  whReceipt: Array<JobMenuItem>,
  standalone: Array<JobMenuItem>,
  utility: Array<JobMenuItem>,
  opReport: Array<JobMenuItem>,
  billings: Array<JobMenuItem>,
  // brokerageTrucking: Array<JobMenuItem>,
  order: Array<JobMenuItem>,
  load: Array<JobMenuItem>,
  localDO: Array<JobMenuItem>,
  myEvent: Array<JobMenuItem>,
  businessIntell: Array<JobMenuItem>,
  orchidBaro: Array<JobMenuItem>,
  ams: Array<JobMenuItem>,
  isf: Array<JobMenuItem>,
  //reportManager: Array<JobMenuItem>,
}

// const timestamp = now();

const initialState:JobMenuState = {
  home: [
    { url: '/home/home', label: 'Quick Menu', parentUrl: null, operationName: constants.operations.home, closeOnLogout: false, metadata:null, counter: 0, timestamp:nowMillisecond(), noOperationSuffix:false }
  ],
  oceanImport: [
    // { url: '/oceanImport/home', label: 'Home', parentUrl: null, operationName: constants.operations.oceanImport, closeOnLogout: false, metadata:null, counter: 0, timestamp }
  ],
  oceanExport: [
    // { url: '/oceanExport/home', label: 'Home', parentUrl: null, operationName: constants.operations.oceanExport, closeOnLogout: false, metadata:null, counter: 0, timestamp }
  ],
  airImport: [
    // { url: '/airImport/home', label: 'Home', parentUrl: null, operationName: constants.operations.airImport, closeOnLogout: false, metadata:null, counter: 0, timestamp }
  ],
  airExport: [
    // { url: '/airExport/home', label: 'Home', parentUrl: null, operationName: constants.operations.airExport, closeOnLogout: false, metadata:null, counter: 0, timestamp }
  ],
  otherShipment: [
    // { url: '/otherShipment/home', label: 'Home', parentUrl: null, operationName: constants.operations.otherShipment, closeOnLogout: false, metadata:null, counter: 0, timestamp }
  ],
  accounting: [
    // { url: '/accounting/home', label: 'Home', parentUrl: null, operationName: constants.operations.accounting, closeOnLogout: false, metadata:null, counter: 0, timestamp }
  ],
  warehousing: [
    // { url: '/warehousing/home', label: 'Home', parentUrl: null, operationName: constants.operations.warehousing, closeOnLogout: false, metadata:null, counter: 0, timestamp }
  ],
  whReceipt:[],
  customer: [],
  standalone: [],
  utility:[],
  opReport: [],
  billings:[],
  // brokerageTrucking:[],
  order:[],
  load:[],
  localDO:[],
  myEvent:[],
  businessIntell:[],
  orchidBaro:[],
  ams:[],
  isf:[]
};

function doMoveJobToOperation(currentState: Draft<JobMenuState>, url: string, sourceOperation: string, destinationOperation: string) {
  if (sourceOperation === destinationOperation) {
    return;
  }

  let sourceSection = currentState[sourceOperation];
  let destinationSection = currentState[destinationOperation];

  const moveItemIndex = sourceSection.findIndex(x => x.url === url);
  if (moveItemIndex >= 0) {
    const moveItems = sourceSection.splice(moveItemIndex, 1);
    moveItems[0].operationName = constants.operations[destinationOperation];
    destinationSection.push(moveItems[0]);
  }
}

function moveScreenToTopForSection(section:Draft<Array<JobMenuItem>>, url:string) {
  if (section.length <= 0 || section[section.length - 1].url === url) {
    // Nothing to do. Either there is no screens on stack or screen with url is already on top
    return;
  }

  const currentIndex = section.findIndex(x => x.url === url);
  if (currentIndex < 0) {
    return;
  }

  const moveItem = section.splice(currentIndex, 1)[0];

  section.push(moveItem);
}

function doAddJobMenuItemToSectionIfNotExists(section:Draft<Array<JobMenuItem>>, newElement:JobMenuItem, afterScreenUrl: string|null) {
  const existingIndex = section.findIndex(x => stringsEqualIgnoreCase(x.url, newElement.url));

  if (existingIndex < 0) {
    if (!!afterScreenUrl) {
      // const afterScreen = section.find(x => x.url === afterScreenUrl);
      // const lastTimestamp = section[section.length - 1].timestamp;
      // if (afterScreen && lastTimestamp) {
      //   newElement.timestamp = addMilliseconds(lastTimestamp, 1000);
      // }
      // if (afterScreen && afterScreen.timestamp) {
      //   newElement.timestamp = addMilliseconds(afterScreen.timestamp, 1000);
      // }
    }
    section.push(newElement);
  } else {
    section[existingIndex].counter = section[existingIndex].counter + 1;
  }
}

function doAddJobMenuItemFromAction(currentState:Draft<JobMenuState>, actionPayload:AddJobMenuItem) {
  const newElement:JobMenuItem = {
    url: actionPayload.url,
    label: actionPayload.label,
    parentUrl: actionPayload.parentUrl,
    operationName: actionPayload.operation ? constants.operations[actionPayload.operation] : '',
    closeOnLogout: actionPayload.closeOnLogout,
    metadata: actionPayload.metadata,
    counter: 0,
    timestamp: nowMillisecond(),
    noOperationSuffix: !!actionPayload.noOperationSuffix,
    jobMode:actionPayload.jobMode,
    afterScreenUrl:actionPayload.afterScreenUrl,
    jobType:actionPayload.jobType,
    addTypeSuffix: !!actionPayload.addTypeSuffix,
  };

  if (!!actionPayload.operation) {
    doAddJobMenuItemToSectionIfNotExists(currentState[actionPayload.operation], newElement, actionPayload.afterScreenUrl);
  } else {
    doAddJobMenuItemToSectionIfNotExists(currentState.oceanImport, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.oceanExport, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.airImport, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.airExport, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.otherShipment, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.accounting, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.customer, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.warehousing, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.whReceipt, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.utility, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.opReport, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.billings, newElement, actionPayload.afterScreenUrl);
    // doAddJobMenuItemToSectionIfNotExists(currentState.brokerageTrucking, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.order, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.load, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.localDO, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.myEvent, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.businessIntell, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.orchidBaro, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.ams, newElement, actionPayload.afterScreenUrl);
    doAddJobMenuItemToSectionIfNotExists(currentState.isf, newElement, actionPayload.afterScreenUrl);
  }
}

function removeJobItemFromSection(section:Draft<Array<JobMenuItem>>, urlToRemove:string) {
  const deleteIndex = section.findIndex(x => x.url === urlToRemove);
  if (deleteIndex < 0) {
    return section;
  }

  //  Build dependency tree of urls to delete
  const urlsToDelete:Array<string> = [];
  let query = [urlToRemove];

  while (query && query.length > 0) {
    urlsToDelete.unshift(...query);
    // eslint-disable-next-line no-loop-func
    query = section.filter(s => query.some(q => stringsEqualIgnoreCase(q, s.parentUrl))).map(x => x.url);
  }

  const deleteIndices = Array.from(new Set( // to remove duplicates
      section.reduce((a, e, i) => {
      if (urlsToDelete.some(d => stringsContainsIgnoreCase(d, e.url))) {
        a.push(i);
      }
      return a;
    }, [] as number[])
  ));
  deleteIndices.sort((a, b) => b-a); // Sort descending

  deleteIndices.forEach(i => section.splice(i, 1));
}

function doReplaceJobMenuItemFromAction(currentState:Draft<JobMenuState>, actionPayload:ReplaceJobMenuItem) {
  const indexInOi = currentState.oceanImport.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInOi >= 0) {
    currentState.oceanImport[indexInOi].url = actionPayload.newUrl;
    currentState.oceanImport[indexInOi].label = actionPayload.newLabel;
    currentState.oceanImport[indexInOi].metadata = actionPayload.metadata;
    currentState.oceanImport[indexInOi].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }

  const indexInOe = currentState.oceanExport.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInOe >= 0) {
    currentState.oceanExport[indexInOe].url = actionPayload.newUrl;
    currentState.oceanExport[indexInOe].label = actionPayload.newLabel;
    currentState.oceanExport[indexInOe].metadata = actionPayload.metadata;
    currentState.oceanExport[indexInOe].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }

  const indexInAi = currentState.airImport.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInAi >= 0) {
    currentState.airImport[indexInAi].url = actionPayload.newUrl;
    currentState.airImport[indexInAi].label = actionPayload.newLabel;
    currentState.airImport[indexInAi].metadata = actionPayload.metadata;
    currentState.airImport[indexInAi].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }

  const indexInAe = currentState.airExport.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInAe >= 0) {
    currentState.airExport[indexInAe].url = actionPayload.newUrl;
    currentState.airExport[indexInAe].label = actionPayload.newLabel;
    currentState.airExport[indexInAe].metadata = actionPayload.metadata;
    currentState.airExport[indexInAe].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }

  const indexInOs = currentState.otherShipment.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInOs >= 0) {
    currentState.otherShipment[indexInOs].url = actionPayload.newUrl;
    currentState.otherShipment[indexInOs].label = actionPayload.newLabel;
    currentState.otherShipment[indexInOs].metadata = actionPayload.metadata;
    currentState.otherShipment[indexInOs].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }

  const indexInAc = currentState.accounting.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInAc >= 0) {
    currentState.accounting[indexInAc].url = actionPayload.newUrl;
    currentState.accounting[indexInAc].label = actionPayload.newLabel;
    currentState.accounting[indexInAc].metadata = actionPayload.metadata;
    currentState.accounting[indexInAc].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }

  const indexInWa = currentState.warehousing.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInWa >= 0) {
    currentState.warehousing[indexInWa].url = actionPayload.newUrl;
    currentState.warehousing[indexInWa].label = actionPayload.newLabel;
    currentState.warehousing[indexInWa].metadata = actionPayload.metadata;
    currentState.warehousing[indexInWa].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }

  const indexInWhr = currentState.whReceipt.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInWhr >= 0) {
    currentState.whReceipt[indexInWhr].url = actionPayload.newUrl;
    currentState.whReceipt[indexInWhr].label = actionPayload.newLabel;
    currentState.whReceipt[indexInWhr].metadata = actionPayload.metadata;
    currentState.whReceipt[indexInWhr].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }

  const indexInCs = currentState.customer.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInCs >= 0) {
    currentState.customer[indexInCs].url = actionPayload.newUrl;
    currentState.customer[indexInCs].label = actionPayload.newLabel;
    currentState.customer[indexInCs].metadata = actionPayload.metadata;
    currentState.customer[indexInCs].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }

  const indexInUtil = currentState.utility.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInUtil >= 0) {
    currentState.utility[indexInUtil].url = actionPayload.newUrl;
    currentState.utility[indexInUtil].label = actionPayload.newLabel;
    currentState.utility[indexInUtil].metadata = actionPayload.metadata;
    currentState.utility[indexInUtil].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }

  const indexInBillings = currentState.billings.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInBillings >= 0) {
    currentState.billings[indexInBillings].url = actionPayload.newUrl;
    currentState.billings[indexInBillings].label = actionPayload.newLabel;
    currentState.billings[indexInBillings].metadata = actionPayload.metadata;
    currentState.billings[indexInBillings].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }

  const indexInMyEvent = currentState.myEvent.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInMyEvent >= 0) {
    currentState.myEvent[indexInMyEvent].url = actionPayload.newUrl;
    currentState.myEvent[indexInMyEvent].label = actionPayload.newLabel;
    currentState.myEvent[indexInMyEvent].metadata = actionPayload.metadata;
    currentState.myEvent[indexInMyEvent].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }

  const indexInBIntell = currentState.businessIntell.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInBIntell >= 0) {
    currentState.businessIntell[indexInBIntell].url = actionPayload.newUrl;
    currentState.businessIntell[indexInBIntell].label = actionPayload.newLabel;
    currentState.businessIntell[indexInBIntell].metadata = actionPayload.metadata;
    currentState.businessIntell[indexInBIntell].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }
  const indexInOrchidBaro = currentState.orchidBaro.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInOrchidBaro >= 0) {
    currentState.orchidBaro[indexInOrchidBaro].url = actionPayload.newUrl;
    currentState.orchidBaro[indexInOrchidBaro].label = actionPayload.newLabel;
    currentState.orchidBaro[indexInOrchidBaro].metadata = actionPayload.metadata;
    currentState.orchidBaro[indexInOrchidBaro].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }

  const indexInAms = currentState.ams.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInBIntell >= 0) {
    currentState.ams[indexInBIntell].url = actionPayload.newUrl;
    currentState.ams[indexInBIntell].label = actionPayload.newLabel;
    currentState.ams[indexInBIntell].metadata = actionPayload.metadata;
    currentState.ams[indexInBIntell].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }
  
  const indexInIsf = currentState.isf.findIndex(x => x.url === actionPayload.oldUrl);
  if (indexInBIntell >= 0) {
    currentState.isf[indexInBIntell].url = actionPayload.newUrl;
    currentState.isf[indexInBIntell].label = actionPayload.newLabel;
    currentState.isf[indexInBIntell].metadata = actionPayload.metadata;
    currentState.isf[indexInBIntell].noOperationSuffix = !!actionPayload.noOperationSuffix;
  }
}

function doReplaceJobMenuItemTimestamp(currentState:Draft<JobMenuState>, actionPayload:ReplaceJobMenuItemTimestamp) {
  const indexInOi = currentState.oceanImport.findIndex(x => x.url === actionPayload.url);
  if (indexInOi >= 0) {
    currentState.oceanImport[indexInOi].timestamp = actionPayload.timestamp;
  }

  const indexInOe = currentState.oceanExport.findIndex(x => x.url === actionPayload.url);
  if (indexInOe >= 0) {
    currentState.oceanExport[indexInOe].timestamp = actionPayload.timestamp;
  }

  const indexInAi = currentState.airImport.findIndex(x => x.url === actionPayload.url);
  if (indexInAi >= 0) {
    currentState.airImport[indexInAi].timestamp = actionPayload.timestamp;
  }

  const indexInAe = currentState.airExport.findIndex(x => x.url === actionPayload.url);
  if (indexInAe >= 0) {
    currentState.airExport[indexInAe].timestamp = actionPayload.timestamp;
  }

  const indexInOs = currentState.otherShipment.findIndex(x => x.url === actionPayload.url);
  if (indexInOs >= 0) {
    currentState.otherShipment[indexInOs].timestamp = actionPayload.timestamp;
  }

  const indexInAc = currentState.accounting.findIndex(x => x.url === actionPayload.url);
  if (indexInAc >= 0) {
    currentState.accounting[indexInAc].timestamp = actionPayload.timestamp;
  }

  const indexInWa = currentState.warehousing.findIndex(x => x.url === actionPayload.url);
  if (indexInWa >= 0) {
    currentState.warehousing[indexInWa].timestamp = actionPayload.timestamp;
  }

  const indexInWhr = currentState.whReceipt.findIndex(x => x.url === actionPayload.url);
  if (indexInWhr >= 0) {
    currentState.whReceipt[indexInWhr].timestamp = actionPayload.timestamp;
  }

  const indexInCs = currentState.customer.findIndex(x => x.url === actionPayload.url);
  if (indexInCs >= 0) {
    currentState.customer[indexInCs].timestamp = actionPayload.timestamp;
  }
  
  const indexInUtil = currentState.utility.findIndex(x => x.url === actionPayload.url);
  if (indexInUtil >= 0) {
    currentState.utility[indexInUtil].timestamp = actionPayload.timestamp;
  }

  const indexInBillings = currentState.billings.findIndex(x => x.url === actionPayload.url);
  if (indexInBillings >= 0) {
    currentState.billings[indexInBillings].timestamp = actionPayload.timestamp;
  }

  // const indexInBrokerageTrucking = currentState.brokerageTrucking.findIndex(x => x.url === actionPayload.url);
  // if (indexInBrokerageTrucking >= 0) {
  //   currentState.brokerageTrucking[indexInBrokerageTrucking].timestamp = actionPayload.timestamp;
  // }

  const indexInOrder = currentState.order.findIndex(x => x.url === actionPayload.url);
  if (indexInOrder >= 0) {
    currentState.order[indexInOrder].timestamp = actionPayload.timestamp;
  }

  const indexInLoad = currentState.load.findIndex(x => x.url === actionPayload.url);
  if (indexInLoad >= 0) {
    currentState.load[indexInLoad].timestamp = actionPayload.timestamp;
  }

  const indexInLocalDO = currentState.localDO.findIndex(x => x.url === actionPayload.url);
  if (indexInLocalDO >= 0) {
    currentState.localDO[indexInLocalDO].timestamp = actionPayload.timestamp;
  }

  const indexInMyEvent = currentState.myEvent.findIndex(x => x.url === actionPayload.url);
  if (indexInMyEvent >= 0) {
    currentState.myEvent[indexInMyEvent].timestamp = actionPayload.timestamp;
  }
  
  const indexInBusinessIntel = currentState.businessIntell.findIndex(x => x.url === actionPayload.url);
  if (indexInBusinessIntel >= 0) {
    currentState.businessIntell[indexInBusinessIntel].timestamp = actionPayload.timestamp;
  }

  const indexInOrchidBaro = currentState.orchidBaro.findIndex(x => x.url === actionPayload.url);
  if (indexInOrchidBaro >= 0) {
    currentState.orchidBaro[indexInOrchidBaro].timestamp = actionPayload.timestamp;
  }

  const indexInAms = currentState.ams.findIndex(x => x.url === actionPayload.url);
  if (indexInBusinessIntel >= 0) {
    currentState.ams[indexInBusinessIntel].timestamp = actionPayload.timestamp;
  }

  const indexInIsf = currentState.isf.findIndex(x => x.url === actionPayload.url);
  if (indexInBusinessIntel >= 0) {
    currentState.isf[indexInBusinessIntel].timestamp = actionPayload.timestamp;
  }
}

function doReplaceJobMenuItemMetadata(currentState:Draft<JobMenuState>, actionPayload:ReplaceJobMenuItemMetadata) {
  const indexInOi = currentState.oceanImport.findIndex(x => x.url === actionPayload.url);
  if (indexInOi >= 0) {
    currentState.oceanImport[indexInOi].metadata = actionPayload.metadata;
  }

  const indexInOe = currentState.oceanExport.findIndex(x => x.url === actionPayload.url);
  if (indexInOe >= 0) {
    currentState.oceanExport[indexInOe].metadata = actionPayload.metadata;
  }

  const indexInAi = currentState.airImport.findIndex(x => x.url === actionPayload.url);
  if (indexInAi >= 0) {
    currentState.airImport[indexInAi].metadata = actionPayload.metadata;
  }

  const indexInAe = currentState.airExport.findIndex(x => x.url === actionPayload.url);
  if (indexInAe >= 0) {
    currentState.airExport[indexInAe].metadata = actionPayload.metadata;
  }

  const indexInOs = currentState.otherShipment.findIndex(x => x.url === actionPayload.url);
  if (indexInOs >= 0) {
    currentState.otherShipment[indexInOs].metadata = actionPayload.metadata;
  }

  const indexInAc = currentState.accounting.findIndex(x => x.url === actionPayload.url);
  if (indexInAc >= 0) {
    currentState.accounting[indexInAc].metadata = actionPayload.metadata;
  }

  const indexInWa = currentState.warehousing.findIndex(x => x.url === actionPayload.url);
  if (indexInWa >= 0) {
    currentState.warehousing[indexInWa].metadata = actionPayload.metadata;
  }

  const indexInWhr = currentState.whReceipt.findIndex(x => x.url === actionPayload.url);
  if (indexInWhr >= 0) {
    currentState.whReceipt[indexInWhr].metadata = actionPayload.metadata;
  }

  const indexInCs = currentState.customer.findIndex(x => x.url === actionPayload.url);
  if (indexInCs >= 0) {
    currentState.customer[indexInCs].metadata = actionPayload.metadata;
  }
  
  const indexInUtil = currentState.utility.findIndex(x => x.url === actionPayload.url);
  if (indexInUtil >= 0) {
    currentState.utility[indexInUtil].metadata = actionPayload.metadata;
  }

  const indexInBillings = currentState.billings.findIndex(x => x.url === actionPayload.url);
  if (indexInBillings >= 0) {
    currentState.billings[indexInBillings].metadata = actionPayload.metadata;
  }

  // const indexInBrokerageTrucking = currentState.brokerageTrucking.findIndex(x => x.url === actionPayload.url);
  // if (indexInBrokerageTrucking >= 0) {
  //   currentState.brokerageTrucking[indexInBrokerageTrucking].metadata = actionPayload.metadata;
  // }

  const indexInOrder = currentState.order.findIndex(x => x.url === actionPayload.url);
  if (indexInOrder >= 0) {
    currentState.order[indexInOrder].metadata = actionPayload.metadata;
  }

  const indexInLoad = currentState.load.findIndex(x => x.url === actionPayload.url);
  if (indexInLoad >= 0) {
    currentState.load[indexInLoad].metadata = actionPayload.metadata;
  }

  const indexInLocalDO = currentState.localDO.findIndex(x => x.url === actionPayload.url);
  if (indexInLocalDO >= 0) {
    currentState.localDO[indexInLocalDO].metadata = actionPayload.metadata;
  }

  const indexInMyEvent = currentState.myEvent.findIndex(x => x.url === actionPayload.url);
  if (indexInMyEvent >= 0) {
    currentState.myEvent[indexInMyEvent].metadata = actionPayload.metadata;
  }
  
  const indexInBusinessIntel = currentState.businessIntell.findIndex(x => x.url === actionPayload.url);
  if (indexInBusinessIntel >= 0) {
    currentState.businessIntell[indexInBusinessIntel].metadata = actionPayload.metadata;
  }

  const indexInOrchidBaro = currentState.orchidBaro.findIndex(x => x.url === actionPayload.url);
  if (indexInOrchidBaro >= 0) {
    currentState.orchidBaro[indexInOrchidBaro].metadata = actionPayload.metadata;
  }
  
  const indexInAms = currentState.ams.findIndex(x => x.url === actionPayload.url);
  if (indexInAms >= 0) {
    currentState.ams[indexInAms].metadata = actionPayload.metadata;
  }
    
  const indexInIsf = currentState.isf.findIndex(x => x.url === actionPayload.url);
  if (indexInIsf >= 0) {
    currentState.isf[indexInIsf].metadata = actionPayload.metadata;
  }
}

function doReplaceJobMenuParentOp(currentState:Draft<JobMenuState>, actionPayload:ReplaceParentOpJobMenuItem) {
  const orgUrl =  actionPayload.url;
  let findUrl = orgUrl.indexOf('parentOp') > -1 ? orgUrl.slice(0,orgUrl.indexOf('parentOp')-1) : orgUrl;

  // for quotation
  const indexInOe = currentState.oceanExport.findIndex(x => { return x.url.startsWith(findUrl); } );
  if (indexInOe >= 0) {
    currentState.oceanExport[indexInOe].url = orgUrl;
  }

  // for quotation
  const indexInAe = currentState.airExport.findIndex(x => { return x.url.startsWith(findUrl); } );
  if (indexInAe >= 0) {
    currentState.airExport[indexInAe].url = orgUrl;
  }

  // for inv, bill, crdb
  const indexInAc = currentState.accounting.findIndex(x => { return x.url.startsWith(findUrl); } );
  if (indexInAc >= 0) {
    currentState.accounting[indexInAc].url = orgUrl;
  }
}

// Implementation note:
//   The common operations (no operation parameter is provided)
// Is added to every section (for each operation). Later when it is removed, it is also removed
// from all operations. That way the order of screens will be consistent for common operations while
// switching between operations in operation menu.
//                                                   (Dario)

/**
 * Slice for controlling Job Menu
 */
const jobMenuSlice = createSlice({
  name: 'jobMenu',
  initialState,
  reducers: {
    clearJobMenu: () => _.cloneDeep(initialState),
    addJobMenuItem: (state, action: PayloadAction<AddJobMenuItem>) => {
      doAddJobMenuItemFromAction(state, action.payload);
    },
    replaceJobMenuItem: (state, action:PayloadAction<ReplaceJobMenuItem>) => {
      doReplaceJobMenuItemFromAction(state, action.payload);
    },
    removeJobMenuItem: (state, action: PayloadAction<RemoveJobMenuItem>) => {
      removeJobItemFromSection(state.oceanImport, action.payload.url);
      removeJobItemFromSection(state.oceanExport, action.payload.url);
      removeJobItemFromSection(state.airImport, action.payload.url);
      removeJobItemFromSection(state.airExport, action.payload.url);
      removeJobItemFromSection(state.otherShipment, action.payload.url);
      removeJobItemFromSection(state.accounting, action.payload.url);
      removeJobItemFromSection(state.warehousing, action.payload.url);
      removeJobItemFromSection(state.opReport, action.payload.url);
      removeJobItemFromSection(state.whReceipt, action.payload.url);
      removeJobItemFromSection(state.customer, action.payload.url);
      removeJobItemFromSection(state.utility, action.payload.url);
      removeJobItemFromSection(state.standalone, action.payload.url);
      removeJobItemFromSection(state.billings, action.payload.url);
      // removeJobItemFromSection(state.brokerageTrucking, action.payload.url);
      removeJobItemFromSection(state.order, action.payload.url);
      removeJobItemFromSection(state.load, action.payload.url);
      removeJobItemFromSection(state.localDO, action.payload.url);
      removeJobItemFromSection(state.myEvent, action.payload.url);
      removeJobItemFromSection(state.businessIntell, action.payload.url);
      removeJobItemFromSection(state.orchidBaro, action.payload.url);
      removeJobItemFromSection(state.ams, action.payload.url);
      removeJobItemFromSection(state.isf, action.payload.url);
    },
    replaceJobMenuMetadata: (state, action:PayloadAction<ReplaceJobMenuItemMetadata>) => {
      doReplaceJobMenuItemMetadata(state, action.payload);
    },
    replaceJobMenuTimestamp: (state, action:PayloadAction<ReplaceJobMenuItemTimestamp>) => {
      doReplaceJobMenuItemTimestamp(state, action.payload);
    },
    moveJobMenuToTop: (state, action: PayloadAction<MoveJobToTop>) => {
      moveScreenToTopForSection(state[action.payload.operation], action.payload.url);
    },
    moveJobToOperation: (state, action: PayloadAction<MoveJobToOperation>) => {
      doMoveJobToOperation(state, action.payload.url, action.payload.sourceOperation, action.payload.destinationOperation);
    },
    replaceJobMenuParentOp: (state, action:PayloadAction<ReplaceParentOpJobMenuItem>) => {
      doReplaceJobMenuParentOp(state, action.payload);
    },
  }
});

export default jobMenuSlice.reducer;

export const {
  clearJobMenu,
  addJobMenuItem,
  replaceJobMenuItem,
  removeJobMenuItem,
  replaceJobMenuMetadata,
  replaceJobMenuTimestamp,
  moveJobMenuToTop,
  moveJobToOperation,
  replaceJobMenuParentOp,
} = jobMenuSlice.actions;
